import MultiChoiceItem from '../../../types/MultiChoiceItem';

const getLabel = (size: number, array: MultiChoiceItem[], allCheckedLabelName = 'Všetky'): string => {
  if (array.every(({ checked }) => checked) || size === 0) {
    return allCheckedLabelName;
  }
  if (size === 1) {
    return array.find(({ checked }) => checked).label;
  }
  if (size > 1 && size < 5) {
    return `${size} položky`;
  }
  return `${size} položiek`;
};
export default getLabel;
